var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 12.0001C16.0009 12.1317 15.9757 12.2621 15.926 12.384C15.8762 12.5058 15.8029 12.6166 15.7102 12.7101L9.71019 18.7101C9.52188 18.8984 9.26649 19.0042 9.00019 19.0042C8.73388 19.0042 8.47849 18.8984 8.29019 18.7101C8.10188 18.5218 7.99609 18.2664 7.99609 18.0001C7.99609 17.7338 8.10188 17.4784 8.29019 17.2901L13.5902 12.0001L8.30019 6.71006C8.13636 6.51876 8.05075 6.27268 8.06047 6.02101C8.0702 5.76933 8.17453 5.53059 8.35262 5.3525C8.53072 5.1744 8.76946 5.07007 9.02113 5.06035C9.27281 5.05063 9.51888 5.13623 9.71019 5.30006L15.7102 11.3001C15.8949 11.4863 15.9991 11.7377 16.0002 12.0001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevron);
export default __webpack_public_path__ + "static/media/right-chevron.8a8b15cfe1037a3e92160db8c2beaa6d.svg";
export { ForwardRef as ReactComponent };